<template>
  <div>
    <img
      src="static/images/cases/eton/isometric.png"
      class="bg-img"
      style="background-color:#1b335e;"
      :class="{ show: eton }"
      alt="ipads"
    />
    <img
      class="bg-img"
      src="/static/images/cases/asket/asket_top_image.png"
      srcset="/static/images/cases/asket/asket_top_image2x.png 2x"
      alt="Asket"
      style="background-color:#F1C71D;object-fit:cover;padding-left:20%;padding-right: 20%;"
      :class="{ show: asket }"
    />
    <img
      class="bg-img"
      src="/static/images/cases/happysocks/happysocks_top_image.png"
      srcset="/static/images/cases/happysocks/happysocks_top_image2x.png 2x"
      alt="Happy Socks"
      style="background-color:#EB452C;object-fit:cover;padding-left:40%;"
      :class="{ show: happysocks }"
    />
    <div class="cases">
      <div class="case-wrapper" v-scroll-reveal="{ delay: 0, distance: '1px' }">
        <div class="case" :class="{ noborder: hover }">
          <span>
            <div
              class="hover"
              @mouseover="(hover = true), (asket = true)"
              @mouseleave="(hover = false), (asket = false)"
              :class="{ fade: hover }"
            >
              <router-link to="/cases/asket">
                <h2>
                  Asket
                </h2>
                <div class="reveal">
                  <p class="op1">
                    Redefining how we consume fashion with a promise to restore
                    the value of garments.
                  </p>
                  <p class="op1">
                    View case →
                  </p>
                </div>
              </router-link>
            </div>
          </span>
        </div>
      </div>
      <div
        class="case-wrapper"
        v-scroll-reveal="{ delay: 200, distance: '1px' }"
      >
        <div class="case" :class="{ noborder: hover }">
          <span>
            <div
              class="hover"
              @mouseover="(hover = true), (happysocks = true)"
              @mouseleave="(hover = false), (happysocks = false)"
              :class="{ fade: hover }"
            >
              <router-link to="/cases/happysocks">
                <h2>
                  Happy Socks
                </h2>
                <div class="reveal">
                  <p class="op1">
                    Bringing happiness and color to every corner of the world
                    since 2008.
                  </p>
                  <p class="op1">
                    View case →
                  </p>
                </div>
              </router-link>
            </div>
          </span>
        </div>
      </div>
      <div
        class="case-wrapper"
        v-scroll-reveal="{ delay: 400, distance: '1px' }"
      >
        <div class="case" :class="{ noborder: hover }">
          <span>
            <div class="hover" :class="{ fade: hover }">
              <h2>
                Eton Shirts
              </h2>
              <div class="reveal">
                <p class="op1">
                  Case coming soon, stay tuned.
                </p>
                <p class="op1" style="display:none;">
                  View case →
                </p>
              </div>
            </div>
          </span>
        </div>
      </div>
      <div
        class="case-wrapper"
        v-scroll-reveal="{ delay: 600, distance: '1px' }"
      >
        <div class="case" :class="{ noborder: hover }">
          <span>
            <div
              class="hover"
              @mouseover="(hover = true), (danielwellington = true)"
              @mouseleave="(hover = false), (danielwellington = false)"
              :class="{ fade: hover }"
            >
              <h2>
                Daniel Wellington
              </h2>
              <div class="reveal">
                <p class="op1">
                  Case coming soon, stay tuned.
                </p>
                <p class="op1" style="display:none;">
                  View case →
                </p>
              </div>
            </div>
          </span>
        </div>
      </div>
      <div
        class="case-wrapper"
        v-scroll-reveal="{ delay: 800, distance: '1px' }"
      >
        <div class="case" :class="{ noborder: hover }">
          <span>
            <div
              class="hover"
              @mouseover="(hover = true), (frankenstorm = true)"
              @mouseleave="(hover = false), (frankenstorm = false)"
              :class="{ fade: hover }"
            >
              <h2>
                Frankenstorm
              </h2>
              <div class="reveal">
                <p class="op1">
                  Case coming soon, stay tuned.
                </p>
                <p class="op1" style="display:none;">
                  View case →
                </p>
              </div>
            </div>
          </span>
        </div>
      </div>
      <div
        class="case-wrapper"
        v-scroll-reveal="{ delay: 1000, distance: '1px' }"
      >
        <div class="case" :class="{ noborder: hover }">
          <span>
            <div
              class="hover"
              @mouseover="(hover = true), (superfront = true)"
              @mouseleave="(hover = false), (superfront = false)"
              :class="{ fade: hover }"
            >
              <h2>
                Superfront
              </h2>
              <div class="reveal">
                <p class="op1">
                  Case coming soon, stay tuned.
                </p>
                <p class="op1" style="display:none;">
                  View case →
                </p>
              </div>
            </div>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "cases",
  beforeCreate: function() {
    document.body.classList.remove("invert");
  },
  data() {
    return {
      hover: false,
      eton: false,
      happysocks: false,
      asket: false
    };
  },
  mounted() {
    var reveals = document.querySelectorAll(".reveal");
    for (var i = 0; i < reveals.length; i++) {
      reveals[i].style.marginBottom = -Math.abs(reveals[i].offsetHeight) + "px";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/typography.scss";
.bg-img {
  opacity: 0;
  transition: opacity 1s cubic-bezier(0.5, 0, 0, 1);
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  object-fit: contain;
  //display:none;
  &.show {
    opacity: 1;
  }
}
.cases {
  height: 100vh;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  .case-wrapper {
    width: calc(100% / 3);
    height: calc(100% / 2);
    box-sizing: border-box;
    .case {
      border: 1px solid rgba(white, 0.02);
      margin: -1px;
      width: calc(100% + 1px);
      height: calc(100% + 1px);
      padding: 5.3vw;
      overflow: hidden;
      display: flex;
      align-items: flex-end;
      &.noborder {
        border-color: transparent;
      }
      .hover {
        width: 100%;
        //height:50%;
        display: flex;
        align-items: flex-end;
        flex-direction: column;
        flex-wrap: wrap;
        justify-content: flex-end;
        position: relative;
        &:after {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background: white;
          display: block;
          opacity: 0;
          transition: all 1s cubic-bezier(0.5, 0, 0, 1);
          z-index: 0;
          filter: blur(100px);
          border-radius: 1000px;
          pointer-events: none;
          display: none;
        }
        a {
          border-bottom: 0 !important;
          width: 100%;
        }
        .reveal {
          opacity: 0;
          transition: all 1.2s cubic-bezier(0.5, 0, 0, 1);
          //transition-delay: 0.1s;
          margin-bottom: -50%;
          position: relative;
          z-index: 1;
          pointer-events: none;
          p {
            margin-bottom: 0;
          }
        }
        h2 {
          position: relative;
          pointer-events: none;
          z-index: 1;
          @include headline-small;
          transition: all 0.3s ease-in-out;
          font-weight: 300;
          width: 100%;
          //margin-bottom:2vh;
        }
        &.fade {
          h2 {
            opacity: 0;
          }
        }
        &:hover {
          h2 {
            opacity: 1 !important;
          }
          .reveal {
            opacity: 1;
            transform: translateY(0);
            margin-bottom: 0 !important;
            //max-height: 150px;
          }
          &:after {
            opacity: 0.2;
          }
        }
      }
    }
  }
}
@media (max-width: $tablet) {
  .cases {
    .case-wrapper {
      width: 50%;
      .case {
        padding: 40px 50px;
      }
    }
  }
}
@media (max-width: $mobile) {
  .cases {
    .case-wrapper {
      width: 100%;
      height: 30vh;
      .case {
        padding: 15px 30px;
      }
    }
  }
}
</style>
